















import Vue from 'vue'
import Vuex from 'vuex'
export default Vue.component('end-section', {
  methods: {
    restart: function () {
      window.location.reload()
    }
  }
})
